import { cardStyles } from '../PendingChangesCard/PendingChangesCard.styles';

export const recalculatedCardStyles = {
  ...cardStyles,
  cursor: 'default',

  '&:hover': {},
};

export const titleStyles = {
  color: 'text.primary',
};
